import { render, staticRenderFns } from "./recharge_detail.vue?vue&type=template&id=660a0050&scoped=true"
import script from "./recharge_detail.vue?vue&type=script&lang=js"
export * from "./recharge_detail.vue?vue&type=script&lang=js"
import style0 from "./recharge_detail.vue?vue&type=style&index=0&id=660a0050&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660a0050",
  null
  
)

export default component.exports